import { z } from 'zod';
import { HttpErrorResponse } from '../../common/validation-error';
import { CmsModuleDefinitionSchema } from './content-module';
export const createCmsModuleRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/cms/modules',
    name: 'create-cms-module',
    request: { body: CmsModuleDefinitionSchema },
    responses: {
        200: CmsModuleDefinitionSchema,
        201: CmsModuleDefinitionSchema,
        400: HttpErrorResponse,
        409: HttpErrorResponse,
    },
};
export const updateCmsModuleRoute = {
    version: 1,
    method: 'PUT',
    path: '/admin/cms/modules/{slug}',
    name: 'update-cms-module',
    request: {
        params: z.object({ slug: z.string().min(1) }),
        body: CmsModuleDefinitionSchema.omit({ slug: true }),
    },
    responses: {
        200: CmsModuleDefinitionSchema,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
